import {
    Activity,
    Archive,
    ArrowLeft,
    ArrowLeftRight,
    ArrowRight,
    ArrowUpRight,
    BadgeCheck,
    Ban,
    Banknote,
    Blocks,
    Bold,
    BriefcaseBusiness,
    Building2,
    Calculator,
    CalendarDays,
    ChartColumn,
    ChartNoAxesCombined,
    Check,
    CheckCircle2,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    ChevronsUpDown,
    CircleCheck,
    CircleHelp,
    CircleOff,
    CirclePlus,
    CirclePoundSterling,
    CircleSlash,
    CircleUserRound,
    CircleX,
    ClipboardList,
    ClipboardPenLine,
    Clock,
    Clock3,
    Columns3,
    Component,
    Copy,
    CopyPlus,
    CreditCard,
    Download,
    Eraser,
    ExternalLink,
    Eye,
    FilePenLine,
    FilePlus2,
    FileText,
    Filter,
    FolderKanban,
    FolderPlus,
    Globe,
    Grid2X2,
    Grid3X3,
    Hammer,
    Headset,
    History,
    Home,
    IdCard,
    Inbox,
    Info,
    Italic,
    KeyRound,
    Languages,
    Layers,
    Layers3,
    LayoutDashboard,
    Link,
    List,
    ListFilter,
    ListOrdered,
    ListTodo,
    LoaderCircle,
    Lock,
    LockKeyhole,
    LogIn,
    LogOut,
    Mail,
    MailCheck,
    MapPin,
    Megaphone,
    Menu,
    MessageSquare,
    MessageSquarePlus,
    MessageSquareText,
    MessagesSquare,
    Moon,
    MoreHorizontal,
    PackageCheck,
    Palette,
    PanelTop,
    PanelTopOpen,
    Paperclip,
    Pause,
    Pencil,
    Percent,
    Phone,
    PhoneCall,
    Play,
    Plug,
    PlugZap,
    Plus,
    Power,
    ReceiptText,
    RefreshCw,
    RotateCcw,
    Route,
    Save,
    Search,
    Send,
    Server,
    Settings,
    Settings2,
    Sheet,
    Shield,
    ShieldAlert,
    ShieldCheck,
    ShieldQuestion,
    ShoppingCart,
    Signature,
    SlidersHorizontal,
    Sparkles,
    Square,
    Star,
    Sun,
    Tag,
    Tags,
    Terminal,
    Ticket,
    TicketPlus,
    Timer,
    Trash2,
    TriangleAlert,
    Underline,
    User,
    UserPlus,
    Users,
    UsersRound,
    WalletCards,
    Webhook,
    X,
    Zap,
    createIcons
} from "lucide";

export const rcdIcons = {
    Activity,
    Archive,
    ArrowLeft,
    ArrowLeftRight,
    ArrowRight,
    ArrowUpRight,
    BadgeCheck,
    Ban,
    Banknote,
    Blocks,
    Bold,
    BriefcaseBusiness,
    Building2,
    Calculator,
    CalendarDays,
    ChartColumn,
    ChartNoAxesCombined,
    Check,
    CheckCircle2,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    ChevronsUpDown,
    CircleCheck,
    CircleHelp,
    CircleOff,
    CirclePlus,
    CirclePoundSterling,
    CircleSlash,
    CircleUserRound,
    CircleX,
    ClipboardList,
    ClipboardPenLine,
    Clock,
    Clock3,
    Columns3,
    Component,
    Copy,
    CopyPlus,
    CreditCard,
    Download,
    Eraser,
    ExternalLink,
    Eye,
    FilePenLine,
    FilePlus2,
    FileText,
    Filter,
    FolderKanban,
    FolderPlus,
    Globe,
    Grid2X2,
    Grid3X3,
    Hammer,
    Headset,
    History,
    Home,
    IdCard,
    Inbox,
    Info,
    Italic,
    KeyRound,
    Languages,
    Layers,
    Layers3,
    LayoutDashboard,
    Link,
    List,
    ListFilter,
    ListOrdered,
    ListTodo,
    LoaderCircle,
    Lock,
    LockKeyhole,
    LogIn,
    LogOut,
    Mail,
    MailCheck,
    MapPin,
    Megaphone,
    Menu,
    MessageSquare,
    MessageSquarePlus,
    MessageSquareText,
    MessagesSquare,
    Moon,
    MoreHorizontal,
    PackageCheck,
    Palette,
    PanelTop,
    PanelTopOpen,
    Paperclip,
    Pause,
    Pencil,
    Percent,
    Phone,
    PhoneCall,
    Play,
    Plug,
    PlugZap,
    Plus,
    Power,
    ReceiptText,
    RefreshCw,
    RotateCcw,
    Route,
    Save,
    Search,
    Send,
    Server,
    Settings,
    Settings2,
    Sheet,
    ShieldAlert,
    ShieldCheck,
    ShieldLock: Shield,
    ShieldQuestion,
    ShoppingCart,
    Signature,
    SlidersHorizontal,
    Sparkles,
    Square,
    Star,
    Sun,
    Tag,
    Tags,
    Terminal,
    Ticket,
    TicketPlus,
    Timer,
    Trash2,
    TriangleAlert,
    Underline,
    User,
    UserPlus,
    Users,
    UsersRound,
    WalletCards,
    Webhook,
    X,
    Zap
};

export const renderRcdIcons = () => {
    createIcons({ icons: rcdIcons });
};
